var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBriefLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5707_95302)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#094381"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18 25.5C6 25 0 10 -8 4.5L-6 44.5H46.5V27.5C38.5 25 30 26 18 25.5Z",
    fill: "#82C4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M20 34C9.5 34.5 3 32 -6 23L-4 43H42.5V31C31 30.5 30.5 33.5 20 34Z",
    fill: "#00C2FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter0_dd_5707_95302)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29L19.8999 28.8499C19.2053 27.808 18.858 27.287 18.3991 26.9098C17.9929 26.5759 17.5248 26.3254 17.0216 26.1726C16.4533 26 15.8271 26 14.5748 26H13.2C12.0799 26 11.5198 26 11.092 25.782C10.7157 25.5903 10.4097 25.2843 10.218 24.908C10 24.4802 10 23.9201 10 22.8V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H13.6C15.8402 11 16.9603 11 17.816 11.436C18.5686 11.8195 19.1805 12.4314 19.564 13.184C20 14.0397 20 15.1598 20 17.4M20 29V17.4M20 29L20.1001 28.8499C20.7947 27.808 21.142 27.287 21.6009 26.9098C22.0071 26.5759 22.4752 26.3254 22.9784 26.1726C23.5467 26 24.1729 26 25.4252 26H26.8C27.9201 26 28.4802 26 28.908 25.782C29.2843 25.5903 29.5903 25.2843 29.782 24.908C30 24.4802 30 23.9201 30 22.8V14.2C30 13.0799 30 12.5198 29.782 12.092C29.5903 11.7157 29.2843 11.4097 28.908 11.218C28.4802 11 27.9201 11 26.8 11H26.4C24.1598 11 23.0397 11 22.184 11.436C21.4314 11.8195 20.8195 12.4314 20.436 13.184C20 14.0397 20 15.1598 20 17.4",
    stroke: "url(#paint0_radial_5707_95302)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5707_95302",
    x: 2,
    y: 6,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5707_95302"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5707_95302"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5707_95302"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.145098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5707_95302",
    result: "effect2_dropShadow_5707_95302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5707_95302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5707_95302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8889 15.05) rotate(50.0936) scale(18.1855 17.3462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA5F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5707_95302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefLibrary);
export default __webpack_public_path__ + "static/media/icon-brief-library.7a2994c00406246e9b3ddc62f7da70aa.svg";
export { ForwardRef as ReactComponent };